import { ScreeningCycleStatus } from '../../core/services/self-takers/self-takers.service';
import { ScreeningCycle } from '../models/self-takers/self-taker.model';

/**
 * Ciclo “cerrado” para la UI: tratamiento definido, cerrado, o etapas finales legacy.
 * Los estados 13–16 son citología en curso y no deben tratarse como finalizados
 * (antes `status_id >= 11` los marcaba mal como terminados).
 */
export function isScreeningCycleWorkflowFinished(statusId: number): boolean {
  if (
    statusId >= ScreeningCycleStatus.CITOLOGY_PENDING &&
    statusId <= ScreeningCycleStatus.CITOLOGY_ANALYZED
  ) {
    return false;
  }
  return statusId >= ScreeningCycleStatus.TREATMENT_DEFINED;
}

/** True solo si este ciclo entra en la rama citología (no basta con `screening_flow`: en servidor es global y aplica también a ciclos HPV-). */
export function isCitologyScreeningFlow(cycle: ScreeningCycle): boolean {
  if (cycle.self_taker_citology != null) {
    return true;
  }
  return (
    cycle.screening_flow === 'citology' &&
    cycle.status_id >= ScreeningCycleStatus.CITOLOGY_PENDING &&
    cycle.status_id <= ScreeningCycleStatus.CITOLOGY_ANALYZED
  );
}
